// NavigationTabs.js
import React from 'react';

const NavigationTabs = ({ activeTab, setActiveTab }) => {
  return (
    <div className="border-b border-gray-200">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <nav className="flex justify-center -mb-px">
          <button
            className={`py-4 px-6 font-medium text-md border-b-2 ${
              activeTab === 'faq'
                ? 'border-[#1C52A0] text-[#1C52A0]'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
            onClick={() => setActiveTab('faq')}
          >
            Frequently Asked Questions
          </button>
          
          <button
            className={`py-4 px-6 font-medium text-md border-b-2 ${
              activeTab === 'guides'
                ? 'border-[#1C52A0] text-[#1C52A0]'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
            onClick={() => setActiveTab('guides')}
          >
            User Guides
          </button>
        </nav>
      </div>
    </div>
  );
};

export default NavigationTabs;